import _Vue from "vue";
import {Moment, MomentInput} from "moment";
import moment from 'moment-timezone/builds/moment-timezone-with-data';
import {DataHelper} from "../../utils/data-helper";
import {getBrowserDateFormat, getBrowserDayMonthFormat, getBrowserMonthDayFormat} from "../../utils/date-helper";
import {DEFAULT_NUMBER_DECIMAL} from "../../common/constants";

export class PluginOptions {
}

const FormatterPlugin = {
	install(Vue: typeof _Vue , options?: PluginOptions) {
        console.log("FormatterPlugin plugin is installing");
        
        Vue.prototype.$formatAppoimentDate = function (value: string) {
            // FRO-10891: day name follows the UI language, numeric order the browser locale.
            const lang = (localStorage.getItem('lang') || 'en').split('-')[0];
            const locale = lang === 'nl' ? 'nl' : lang === 'fr' ? 'fr' : 'en';
            return moment(value).locale(locale).format(`ddd ${getBrowserDayMonthFormat()} HH:mm`);
        }
		
		/**
		 * format date by locale
		 * note: this is format using for element ui date time picker
		 * i had replace some format from moment because element ui using another format
		 * IMPORTANT: BY REQUEST CHANGE THAT DO NOT USING THE FORMAT BY MOMENT AND HARD CODE FORMAT BY LANGUAGE
		 */
		Vue.prototype.$formatDate = function () {
			// FRO-10891: element-ui picker display format, derived from the browser locale.
			return getBrowserDateFormat().replace(/D/g, "d").replace(/Y/g, "y");
		};

		/**
		 * FORMAT DATE USING FOR MOMEMTN
		 */
		Vue.prototype.$formatDateMoment = function () {
			// FRO-10891: numeric moment date format, derived from the browser locale.
			return getBrowserDateFormat();
		};

		/**
		 * FORMAT DATE USING FOR MOMEMTN
		 */
		Vue.prototype.$formatDateMonthMoment = function () {
			// FRO-10891: month/day order, derived from the browser locale.
			return getBrowserMonthDayFormat();
		};

		Vue.prototype.$formatTime = function () {
			return "HH:mm:ss";
		};
		
		/**
		 * FORMAT DATETIME FOR ELEMENT UI
		 */
		Vue.prototype.$formatDateTime = function () {
			let self = this as any;
			return self.$formatDate() + " " + self.$formatTime();
		};
		
		Vue.prototype.$nf = function (value: any) {
			if (value !== undefined && value !== null)
				return Intl.NumberFormat(this.$i18n.locale , {
					maximumFractionDigits: DEFAULT_NUMBER_DECIMAL.maximumFractionDigits
				}).format(value);
			else return value;
		};
		
		Vue.prototype.$currencyFormat = function (value: any) {
			if (value == null) return 0;
			const lang = localStorage.getItem("lang");
			
			return value.toLocaleString(lang , {
				minimumFractionDigits: 2 ,
				maximumFractionDigits: 2
			});
		};
		
		Vue.prototype.$getStaticUrl = (path) => {
			return DataHelper.getStaticRootUrl() + path;
		};
		
		Vue.prototype.$getMomentByLocale = function (): Moment {
			moment.updateLocale(this.$i18n.locale.substr(0 , 2) , {
				week: {
					dow: 1 ,
					doy: 7
				}
			});
			return moment();
		};

		Vue.prototype.$formatDateTimeByLocale = function (value: string) {
			let format = this.$formatDateMoment() + " " + this.$formatTime();

			//Read datetime from API as (GMT+1)/ GMT+2 (for Task module)
			let date = moment.tz(value, "Europe/Brussels");
			if (!date.isValid()) return value;
			
			return moment.utc(date.format()).local().format(format);
		}

		Vue.prototype.$formatDateTimeFromUTCToLocale = function (value: string) {
			let format = this.$formatDateMoment() + " " + this.$formatTime();

			let date = moment.utc(value);

			if (!date.isValid()) return value;
			
			return moment.utc(value).local().format(format);
		}

		Vue.prototype.$formatDateTimeFromUTCToEndOfDayLocale = function (value: string) {
			let format = this.$formatDateMoment() + " " + this.$formatTime();

			let date = moment.utc(value);

			if (!date.isValid()) return value;
			
			return moment.utc(value).local().endOf('day').format(format);
		}

		Vue.prototype.$isExpired = function (value: string) {
			const expiredDateTime = this.$formatDateTimeFromUTCToEndOfDayLocale(value);
			let format = this.$formatDateMoment() + " " + this.$formatTime();

			return moment().startOf('day').isAfter(moment(expiredDateTime, format));
		}

		Vue.prototype.$formatDateByLocale = function (value: string) {
			let format = this.$formatDateMoment();

			//Read datetime from API as (GMT+1)/ GMT+2 (for Task module)
			let date = moment.tz(value, "Europe/Brussels");
			if (!date.isValid()) return value;
			
			return moment.utc(date.format()).local().format(format);
		}

		Vue.prototype.$formatDateTimeAsServer = function (value: string) {

			// Parse datetime of current locale into server locale (GMT+1)/(GMT+2)
			let date = moment(value).tz("Europe/Brussels");
			if (!date.isValid()) return value;
			return date.format();
		}
	}
};

export default FormatterPlugin;

declare module 'vue/types/vue' {
	interface Vue {
		$getMomentByLocale: () => Moment;
		$formatDateByLocale: (value: string) => String;
		// Declared as MomentInput, not string, because that is what the body accepts: it hands the
		// value straight to moment.tz. Callers that already pass a Date had to cast `this as any`
		// to get past the narrower type - widening it removes the cast instead of spreading it.
		$formatDateTimeByLocale: (value: MomentInput) => String;
		$formatDateTimeAsServer: (value: string) => String;
	}
}

